const LOGO_PATHS: Record<string, string> = {
  "11141": "11141",
  "11343": "11343",
  "11383": "11383",
  "11222": "11222",
  "11197": "11197",
  "11339": "11339",
  "11530": "11530",
};
const SEPAH_BROKER_FUND_CODES = new Set(["11222", "11197", "11530"]);
const INVESTMENT_DISABLED_FUND_CODES = new Set(["11339"]);

export const formatFundNumber = (num: number): string =>
  new Intl.NumberFormat("fa-IR").format(num);

export const formatFundCurrency = (num: number): string => {
  if (num >= 1_000_000_000_000) {
    return `${(num / 1_000_000_000_000).toFixed(1)} هزار میلیارد`;
  }
  if (num >= 1_000_000_000) {
    return `${(num / 1_000_000_000).toFixed(1)} میلیارد`;
  }
  if (num >= 1_000_000) {
    return `${(num / 1_000_000).toFixed(1)} میلیون`;
  }

  return formatFundNumber(num);
};

export const formatFundPercent = (value: number): string => value.toFixed(2);

export const getFundTypeColor = (type: string): string => {
  if (type.includes("سهامی")) return "red";
  if (type.includes("درآمد ثابت")) return "green";
  if (type.includes("مختلط")) return "purple";
  if (type.includes("کالایی")) return "orange";

  return "gray";
};

export const getFundLogoSrc = (fundRegisterCode: string): string | null =>
  LOGO_PATHS[fundRegisterCode]
    ? `/images/funds/${LOGO_PATHS[fundRegisterCode]}/logo.png`
    : null;

export const isSepahBrokerFund = (fundRegisterCode?: string): boolean =>
  SEPAH_BROKER_FUND_CODES.has(String(fundRegisterCode || "").trim());

export const isFundInvestmentEnabled = (fundRegisterCode?: string): boolean =>
  !INVESTMENT_DISABLED_FUND_CODES.has(String(fundRegisterCode || "").trim());

export const getFundSubscriptionPriceLabel = (
  fundRegisterCode?: string,
): string => (isSepahBrokerFund(fundRegisterCode) ? "قیمت خرید" : "قیمت صدور");

export const getFundRedemptionPriceLabel = (
  fundRegisterCode?: string,
): string => (isSepahBrokerFund(fundRegisterCode) ? "قیمت فروش" : "قیمت ابطال");

export const getFundSubscriptionNavLabel = (
  fundRegisterCode?: string,
): string => (isSepahBrokerFund(fundRegisterCode) ? "NAV خرید" : "NAV صدور");

export const getFundRedemptionNavLabel = (fundRegisterCode?: string): string =>
  isSepahBrokerFund(fundRegisterCode) ? "NAV فروش" : "NAV ابطال";
